import { phrasesApi } from '@/api'
import { ref } from 'vue'
import { SAPConfiguration } from '@coac-gmbh/saifty-phrases'
import { useAuth } from '@/auth'

const sapConfig = ref<SAPConfiguration[]>([])
let configLoadingPromise: Promise<void> | undefined

async function loadConfig() {
  const auth = useAuth()

  if (!auth?.isAuthenticated) {
    return
  }

  const { data } = await phrasesApi.getSAPConfigurations()
  sapConfig.value = data || []
}

function ensureConfigLoaded() {
  if (!configLoadingPromise) {
    configLoadingPromise = loadConfig()
  }
}

export function useSAPConfig() {
  const auth = useAuth()
  ensureConfigLoaded()

  function getConfigByBusinessUnit(businessUnit?: string) {
    if (!businessUnit) return undefined

    return sapConfig.value.find(
      (config) =>
        config.system === businessUnit && config.sap_user_role && auth.user?.roles.includes(config.sap_user_role)
    )
  }

  return { getConfigByBusinessUnit }
}
